/* @flow */
import _ from 'lodash';
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

class Prompt extends Entity {
  initialize() {
    this.url = '/prompts';
  }

  defaults() {
    return {
      created_at: new Date(),
      responded_at: new Date(),
    };
  }

  parse(response: Object) {
    const p = _.clone(response);
    p['created_at'] = new Date(p['created_at']);
    p['responded_at'] = new Date(p['responded_at']);
    return p;
  }

  isNew() {
    return true;
  }

  getAction() {
    return this.get('action');
  }

  getCreatedAt() {
    return this.get('created_at');
  }

  getRespondedAt() {
    return this.get('responded_at');
  }

  getResponse() {
    return this.get('response');
  }

  getMessageId() {
    return this.get('message_id');
  }

  isLessThanDaysOld(days: number) {
    return this.getCreatedAt() >= Date.now() - days * 24 * 60 * 60 * 1000;
  }

  static savePrompt(prompt: Prompt) {
    return prompt.save({}, {
      data: {
        prompt: {
          action: prompt.getAction(),
          response: prompt.getResponse(),
        },
      },
    });
  }

  static markDismissed(prompt: Prompt): Promise<{response: string}> {
    const promptId = prompt.id;
    if (prompt.id) {
      // 1) Recent Prompts: Dismissed with a PATCH and prompt.id
      return apiRequest(`/prompts/${promptId}/`, 'PATCH', {
        response: 'dismissed',
      });
    } else {
      // 2) Prompts Inventory: Dismissed with a POST, prompt.action, and response="dismissed"
      return apiRequest('/prompts/', 'POST', {
        prompt: {
          action: prompt.getAction(),
          response: 'dismissed',
        },
      });
    }
  }
}

export default Prompt;



// WEBPACK FOOTER //
// ./src/entities/Prompt.js